import { appPostStructuredMessage } from '@common/utils/appUtils';
import analytics from '@utils/analytics';
import classNames from 'classnames';
import React from 'react';
const ArticleThumbnail = ({ article, bottomModule, landscape }) => {
    const { titleAnalytics, title, image, url, day, month, year, /*landscape,*/ imgAlt /*, image2, img2Alt*/ } = article;
    const showOrder = window.location.search.includes('showOrder');
    const handleClick = () => {
        if (window.appmode) {
            appPostStructuredMessage('firebase_analytics', {
                event: 'moncler_now_interactions',
                params: {
                    Action: 'moncler_now-thumbnail_articles-' + `${titleAnalytics || title}`,
                    pageDetail: 'monclernow',
                },
            });
        }
        if (landscape) {
            analytics.landscapeImageClick(title);
        }
        else {
            analytics.thumbnailClick(title);
        }
    };
    return (React.createElement("li", { className: classNames('monclernow-listing__article', { 'article--landscape': landscape && !bottomModule, 'article--two-images': /*image2*/ false && !bottomModule }) },
        showOrder && React.createElement("div", { className: "monclernow-listing__number-order" }, article.position),
        React.createElement("article", null,
            React.createElement("a", { onClick: handleClick, href: url },
                React.createElement("span", { className: "article__image-wrapper" },
                    React.createElement("span", { className: "image-wrapper__img" },
                        React.createElement("img", { src: image + (landscape ? '&sw=1920' : '&sw=768&sh=768'), alt: imgAlt || '', "aria-hidden": "true" }))),
                React.createElement("span", { className: "article__info-wrapper" },
                    (article === null || article === void 0 ? void 0 : article.categoryname) && React.createElement("span", { className: "info-wrapper__category" }, article === null || article === void 0 ? void 0 : article.categoryname),
                    day && month && month && (React.createElement("span", { className: "info-wrapper__date" },
                        React.createElement("time", { dateTime: `${year}-${month.length < 2 ? '0' + month : month}-${day}` }, `${day}.${month}.${year === null || year === void 0 ? void 0 : year.slice(2, year.length)}`))),
                    title && React.createElement("span", { className: "info-wrapper__title" }, title))))));
};
export default ArticleThumbnail;
